import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { PagesContentDTO } from '../../../api/pages-content-api';
import SvgClose from '../../../assets/icons/Close';
import SvgDelete from '../../../assets/icons/Delete';
import SvgSave from '../../../assets/icons/Save';
import { BasicModal } from '../../../components/basic/basic-modal';
import { T } from '../../../components/basic/text';
import { yup } from '../../../components/basic/yup';
import { FormikTextField } from '../../../components/formik';
import FormikTextEditor from '../../../components/formik/formik-text-editor';

interface SavePagesContentModalProps {
    show: boolean;
    allowEdit: boolean;
    selectedPagesContent?: PagesContentDTO;
    selectedPageId: string;
    onHide: () => void;
    onSave: (values: PagesContentDTO) => void;
    onDelete?: (pagesContent: PagesContentDTO) => void;
}

export function SavePagesContentModal({
    show,
    allowEdit,
    selectedPagesContent,
    selectedPageId,
    onHide,
    onSave,
    onDelete,
}: SavePagesContentModalProps) {
    const PagesContentSchema = yup.object().shape({
        sectionOrder: yup.number().required(' '),
        heading: yup.string().required(' '),
        content: yup.string().required(' '),
    });

    const defaultValues: PagesContentDTO = {
        id: selectedPagesContent?.id,
        pageId: selectedPagesContent ? selectedPagesContent.pageId : selectedPageId,
        sectionOrder: selectedPagesContent ? selectedPagesContent.sectionOrder : 0,
        heading: selectedPagesContent ? selectedPagesContent.heading : '',
        content: selectedPagesContent ? selectedPagesContent.content : '',
    };

    if (!show) return <></>;

    return (
        <Formik
            initialValues={defaultValues}
            validationSchema={PagesContentSchema}
            onSubmit={onSave}
        >
            {formik => (
                <BasicModal
                    show={show}
                    onHide={onHide}
                    fullScreen
                    title={
                        <bd.Flex className="w-100" align="center" content="between">
                            <T>
                                {selectedPagesContent ? 'edit-pages-content' : 'new-pages-content'}
                            </T>
                            <bd.Flex align="center" gap={2}>
                                <bd.Button
                                    variant="icon"
                                    size="sm"
                                    onClick={formik.submitForm}
                                    disabled={!allowEdit}
                                >
                                    <SvgSave />
                                </bd.Button>
                                {selectedPagesContent && onDelete && (
                                    <bd.Button
                                        disabled={!allowEdit}
                                        variant="icon"
                                        color="secondary"
                                        size="sm"
                                        onClick={() => onDelete(selectedPagesContent)}
                                    >
                                        <SvgDelete />
                                    </bd.Button>
                                )}
                                <bd.Button
                                    variant="icon"
                                    color="secondary"
                                    size="sm"
                                    onClick={onHide}
                                >
                                    <SvgClose />
                                </bd.Button>
                            </bd.Flex>
                        </bd.Flex>
                    }
                >
                    <Form>
                        <bd.Flex align="center" wrap>
                            <FormikTextField
                                label="section-order"
                                name="sectionOrder"
                                readOnly={!allowEdit}
                                width="7rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="heading"
                                name="heading"
                                readOnly={!allowEdit}
                                className="flex-grow-1"
                                handleEnter
                            />

                            <FormikTextEditor
                                label="content"
                                name="content"
                                readOnly={!allowEdit}
                                className="w-100"
                            />
                        </bd.Flex>
                    </Form>
                </BasicModal>
            )}
        </Formik>
    );
}
